import React, { useEffect, useState } from "react";

const Ats = () => {
    const [swiftConnection, setSwiftConnection] = useState(true);
    useEffect(()=>{
        const intervalId = setInterval(() => {
            setSwiftConnection(prevState => !prevState);
          }, 10000); 
      
          return () => {
            clearInterval(intervalId);
          };
    },[]);

  return (
    <svg>
      <g id="ATS">
        <svg>
          <g
            id="ATS"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect
              id="Rectangle-Copy-24"
              stroke="var(--se-sld-circline)"
              strokeWidth="3"
              x="470"
              y="295"
              width="200"
              height="75"
              rx="16"
            ></rect>
            <text
              id="AAA"
              font-family="Nunito-Regular, Nunito"
              font-size="16"
              font-weight="normal"
              stroke="var(--se-sld-circline)"
              fill="var(--se-sld-circline)"
            >
              <tspan x="592" y="360">
                ATS
              </tspan>
            </text>
          </g>
        </svg>
        <svg width="70px" height="91px" viewBox="0 0 10 149" x={507} y={310}>
          <g id="ATS-ID">
            <line
              x1="48.5"
              y1="70.1701389"
              x2="48.501111"
              y2="145"
              id="Line-2-Copy-15"
              stroke=  {"var(--se-sld-circline)"}
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
          </g>
        </svg>
        <svg x={392} y={237} width="300px" height="140px" viewBox="0 0 100 160">
          <circle
            id="pm inner"
            stroke=  {"var(--se-sld-circline)"}
            strokeWidth="3"
            cx="80"
            cy="127"
            r="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="var(--se-background-alternative)"
          ></circle>
       { swiftConnection &&  <line
            x1="42"
            y1="90"
            x2="78"
            y2="125"
            id="Line-3"
            stroke="var(--se-sld-circline)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></line>}
         { !swiftConnection && <line
            x1="127"
            y1="93"
            x2="83"
            y2="124"
            id="Line-3"
            stroke="var(--se-sld-circline)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></line>}
        </svg>
      </g>
    </svg>
  );
};

export default Ats;
